import React, { useState } from "react";
import {
  Card,
  Table,
  Button,
  Space,
  Tag,
  Popconfirm,
  message,
} from "antd";

import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import MasterModal from "./MasterModal";

const MasterTable = ({
  title,
  rows,
  loading,
  onCreate,
  onUpdate,
  onDelete,
  type,
  lockSystemRows = false,
}) => {
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const handleSubmit = async (values) => {
    try {
      if (editing) {
        await onUpdate({
          ...editing,
          ...values,
        });

        message.success(`${type} updated`);
      } else {
        await onCreate(values);

        message.success(`${type} created`);
      }

      setOpen(false);
      setEditing(null);
    } catch (err) {
      message.error(err?.message || "Failed");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },

    ...(type === "Status"
      ? [
          {
            title: "Color",
            dataIndex: "color",
            render: (v) => (
              <Tag color={v}>
                {v}
              </Tag>
            ),
          },
        ]
      : []),

    // {
    //   title: "System",
    //   dataIndex: "is_system",
    //   render: (v) =>
    //     v ? (
    //       <Tag color="gold">
    //         SYSTEM
    //       </Tag>
    //     ) : (
    //       "-"
    //     ),
    // },

    {
      title: "Actions",
      render: (_, row) => (
        <Space>
          {lockSystemRows && row.is_system ? (
            <Tag>Built-in</Tag>
          ) : (
            <>
              <Button
                icon={<EditOutlined />}
                onClick={() => {
                  setEditing(row);
                  setOpen(true);
                }}
              />

              <Popconfirm
                title={`Delete ${type}?`}
                onConfirm={() =>
                  onDelete(row.id)
                }
              >
                <Button
                  danger
                  icon={<DeleteOutlined />}
                />
              </Popconfirm>
            </>
          )}
        </Space>
      ),
    },
  ];

  return (
    <>
      <Card
        title={title}
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditing(null);
              setOpen(true);
            }}
          >
            Add
          </Button>
        }
      >
        <Table
          rowKey="id"
          columns={columns}
          dataSource={rows}
          loading={loading}
          pagination={false}
          scroll={{ x: "max-content" }}
        />
      </Card>

      <MasterModal
        open={open}
        editing={editing}
        type={type}
        onClose={() => {
          setOpen(false);
          setEditing(null);
        }}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default MasterTable;